const Services_Data = [
	{
		s_no: '01',
		s_name: 'Analyst & Consultant',
		s_description:
			'Extracting, cleaning, and uncovering trends from raw data using SQL, Python, and R. Transforming complex numbers into clear, interactive Power BI & Tableau dashboards that help businesses make data-driven decisions.',
	},
	{
		s_no: '02',
		s_name: ' Coding Instructor',
		s_description:
			'Simplifying data science, Python, and AI concepts for students and tech enthusiasts. Delivering hands-on programming sessions and helping future developers master data analysis fundamentals.',
	},

	{
		s_no: '03',
		s_name: 'Frontend & Analytics Developer',
		s_description:
			'Building responsive web platforms and custom data-driven applications using React.js and modern frontend tools. Bridging the gap between clean UI design and functional data experiences.',
	},
];

export default Services_Data;
